import axios from './axios.config';
import paramsMerge from './encryption'

const catchError = () => {
    var errData = {
        Code: "10040",
        Msg: "请求超时",
        Memo: "-1",
        Data: null
    }
    return errData
}

// 所有 请求
export default {
    // 获取PC 首页轮播图片
    async getByThePictureImgs() {
        try {
            const res = await axios.post("/AccountLogin/SearchBanners");
            return res.data
        } catch (e) {
            return catchError();
        }
    },

    /** 登录 start */
    // 获取图形验证码
    async getGetcaptcha() {
        const params = paramsMerge({
            userid: "sso"
        });
        const res = await axios.post("/AccountLogin/GeetestRegister", params);
        return res;
    },
    // 获取酒店列表  如果 返回结果数组不为空 显示酒店列表选项
    // {Data: _encrypt($.trim($(domID).val())), _: Math.random() }
    async getTheHotelList(params) {
        try {
            const paramst = paramsMerge(params);
            const res = await axios.post("/AccountLogin/SearchHotelInfoByKeyRequest", paramst);
            return res.data
        } catch (e) {
            return catchError();
        }
    },
    /** 登录 */
    async postLogin(params) {
        try {
            const paramst = paramsMerge(params);
            const res = await axios.post("/AccountLogin/SignIn", paramst);
            return res.data;
        } catch (e) {
            return catchError();
        }
    },
    /** 手机号登录 获取验证码j */
    async getPhoneSendKey(params) {
        try {
            const paramst = paramsMerge(params);
            const res = await axios.post("/AccountLogin/CheckAndSendKey", paramst);
            return res.data;
        } catch (e) {
            return catchError();
        }
    },
    /** 登录 end */
    /** 密码找回 */
    /** 验证用户名 */
    async getDoesTheUserExist(params) {
        try {
            const paramst = paramsMerge(params);
            const res = await axios.post("/AccountLogin/CheckUserUserNameOrCtfNo", paramst);
            return res.data;
        } catch (e) {
            return catchError();
        }
    },
    /** 修改密码找回密码 手机号验证码验证 */
    async getValiSmsKey(params) {
        try {
            const paramst = paramsMerge(params);
            const res = await axios.post("/AccountLogin/ValiSmsKey", paramst);
            return res.data;
        } catch (e) {
            return catchError();
        }
    },
    /** 修改密码重新设置密码  */
    async modifyPassword(params) {
        try {
            const paramst = paramsMerge(params);
            const res = await axios.post("/AccountLogin/ModifyPassword", paramst);
            return res.data;
        } catch (e) {
            return catchError();
        }
    },
    /** 绑定微信 */
    async bindingWx(params) {
        try {
            const paramst = paramsMerge(params);
            const res = await axios.post("/AccountLogin/UnionBing", paramst);
            return res.data;
        } catch (e) {
            return catchError();
        }
        // const paramst = paramsMerge(params);
    }
}
